import { Injectable } from '@angular/core';
import { MfsStorageProvider } from '@office-start/spaces-storage-service';
import { AccessTokenConsumer, AccessTokenService } from '../shared/services/access-token.service';

import { ClientStartupConfigService } from '../shared/shared-context/client-startup-config.service';
import { ContextService } from '../shared/shared-context/context.service';

@Injectable({
    providedIn: 'root'
})
export class SpacesService {
    private _spacesStorageProvider: Promise<MfsStorageProvider>;

    constructor(
        private readonly accessTokenService: AccessTokenService,
        private readonly clientStartupConfigService: ClientStartupConfigService,
        private readonly contextService: ContextService
    ) {
    }

    public getSpacesStorageProvider(): Promise<MfsStorageProvider> {
        if (!this._spacesStorageProvider) {
            this._spacesStorageProvider = import(/*webpackChunkName: "spaces-storage-service" */ '@office-start/spaces-storage-service').then(
                mod => mod.MfsStorageProvider.getOrCreateAsync({
                    // Get from usercontext
                    getToken: async () => {
                        const tokenResponse = await this.accessTokenService.getAccessToken(AccessTokenConsumer.MfsService);
                        return tokenResponse?.token || '';
                    },
                    tenantId: this.clientStartupConfigService.config.tenantId,
                    userObjectId: this.clientStartupConfigService.config.objectId,
                    userPuid: this.clientStartupConfigService.config.puid,
                    useTinylicious: this.contextService.sharedContext.inMockMode
                }));
        }
        return this._spacesStorageProvider;
    }
}
